import React from 'react';

const Blogs = () => {
    return (
        <div>
            <h1>Comming soon</h1>
        </div>
    );
};

export default Blogs;